import React from "react"

import styled from "styled-components"

import { StaticQuery, Link } from "gatsby"

import { Grid } from "../../atoms/grid"
import { Eventlogo } from "../../atoms/logo"
import { Social } from "../../atoms/social"
import { ButtonLink } from "../../atoms/buttons"

import { Navlinks } from "../../molecules/navlinks"

import { Settings } from "../../../styles/theme"

import Hamburger from "../../../images/icons/menu.svg"
import Search from "../../../images/search.png"
import { MobileMenu } from "../../molecules/mobileMenu"

import SiteContext from "../../../context/SiteContext"

const Headerstyled = styled.div`
  position: fixed;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0px 3px 6px #0000004d;
  z-index: 999;
  width: 100%;
  .border {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
  .social {
    div {
      margin-left: auto;
      text-align: right;
      a {
        text-align: right;
        font-weight: 700;
        font-size: 0.8rem;
        text-decoration: none;
        color: ${Settings.primaryColor};
        img:not(.fb) {
          height: 22px;
          width: 22px;
        }
        .fb {
          height: 20px !important;
          width: 20px;
        }
      }
    }
  }
  .constraint {
    @media screen and (max-width: ${Settings.sizeM}) {
      text-align: center;
    }
  }
  .menu {
    margin-left: auto;
  }
  .icon {
    transform: translateY(0.3);
    padding: ${props => (props.top ? "1rem 0" : "0")};
    a > div {
      width: 5rem;
      transform-origin: 50% 30%;
      transition: transform 125ms ease-in-out;
      transform: ${props => (props.top ? "scale(1)" : "scale(0.5)")};
    }
  }
  .grid {
    > div {
      > div:nth-of-type(1) {
        height: ${props => (props.top ? "auto" : "4rem")};
        flex: 1 1 7%;
        @media screen and (max-width: ${Settings.sizeM}) {
          flex: 35%;
        }
      }
      > div:nth-of-type(2) {
        flex: 1 1 50%;
      }
      > div:nth-of-type(3) {
        flex: 1 1 30%;
        @media screen and (max-width: ${Settings.sizeM}) {
          flex: 65%;
        }
      }
    }
  }
  .cta {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    @media screen and (max-width: ${Settings.sizeM}) {
      display: none !important;
    }
    button {
      padding: 0.5rem 1rem;
    }
    .search {
      height: 32px;
      width: 32px;
      margin-left: 1rem;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
`

export class Header extends React.Component {
  state = {
    menu: false,
    top: true,
  }

  handleToggle = () => {
    this.setState({
      menu: !this.state.menu,
      top: true,
    })
  }

  handleScroll = () => {
    if (typeof window !== "undefined") {
      if (window.pageYOffset > 0) {
        this.setState({
          top: false,
        })
      } else {
        this.setState({
          top: true,
        })
      }
    }
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll)
  }

  render() {
    return (
      <Headerstyled top={this.state.top}>
        <div className="border">
          <div className="constraint">
            <Grid unstack columns={2} className="grid-nav">
              <div>
                <p>
                  <b>
                    {this.context.trade === true ||
                    this.context.trade === "true"
                      ? "15 - 20 FEB 2022"
                      : "15 & 16 FEB 2020"}
                  </b>{" "}
                  | Changi Exhibition Centre, Singapore
                </p>
              </div>
              <div className="social hide-on-medium">
                <Grid unstack>
                  {/* 
                  <div>
                    <Link
                      to={
                        this.context.trade === true ||
                        this.context.trade === "true"
                          ? "/public"
                          : "/trade"
                      }
                    >
                      {this.context.trade === true ||
                      this.context.trade === "true"
                        ? "GO TO PUBLIC SITE"
                        : "GO TO TRADE SITE"}{" "}
                      <b>^</b>
                    </Link>
                  </div>
                  */}
                  <Social />
                </Grid>
              </div>
            </Grid>
          </div>
        </div>
        <div className="constraint grid">
          <Grid unstack>
            <div className="icon" onScroll={() => this.handleScroll}>
              <Link
                to={
                  this.context.trade === true || this.context.trade === "true"
                    ? "/"
                    : "/"
                }
              >
                <Eventlogo />
              </Link>
            </div>
            <div className="hide-on-medium" style={{ textAlign: "center" }}>
              <Navlinks />
            </div>
            <div style={{ textAlign: "right", marginRight: "1rem" }}>
              <div className="hide-on-medium cta">
                {/*                <div className="button">
                  <ButtonLink
                    track={
                      this.context.trade === true
                        ? "DC-6953330/sgair0/fronc00+per_session"
                        : false
                    }
                    slug={
                      this.context.trade === true ||
                      this.context.trade === "true"
                        ? "https://app.singaporeairshow.com/"
                        : "https://www.sistic.com.sg/events/sas1502"
                    }
                    external={
                      this.context.trade === true ||
                      this.context.trade === "true"
                        ? true
                        : true
                    }
                    text={
                      this.context.trade === true ||
                      this.context.trade === "true"
                        ? "REGISTER"
                        : "PURCHASE TICKETS"
                    }
                  />
                  </div>*/}
                <Link to="/search" className="search">
                  <img src={Search} alt="Search" />
                </Link>
              </div>
              <div className="show-on-medium">
                <img
                  src={Hamburger}
                  alt="Menu"
                  className="menu"
                  onClick={() => this.handleToggle()}
                />
                <MobileMenu
                  toggle={this.state.menu}
                  callback={this.handleToggle}
                />
              </div>
            </div>
          </Grid>
        </div>
      </Headerstyled>
    )
  }
}

Header.contextType = SiteContext
